import { RecipeSlideshow } from "./RecipeSlideshow";
export default RecipeSlideshow;
